import React, { useState, useEffect } from "react";
import "./RelatorioMeta.css";
import {ComposedChart,
  LabelList, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
  BarChart, Bar, Legend, Cell, PieChart, Pie
} from "recharts";
import { ArrowUpFromLine, ArrowDownFromLine } from "lucide-react";
import { formatarDataBrasil } from "../../utils/utils";
import DateRangePresets from "../../components/DateRangePresets";
import RelatorioSkeleton from "../../components/RelatorioSkeleton";

function RelatorioMetaCompleto() {
  const [dados, setDados] = useState(null);
  const [usuarios, setUsuarios] = useState([]);
  const [usuarioSelecionado, setUsuarioSelecionado] = useState("");
  const [anuncios, setAnuncios] = useState([]);
  const hoje = new Date().toISOString().slice(0, 10);
  const primeiroDiaDoMes = new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().slice(0, 10);
  const [dataInicio, setDataInicio] = useState(primeiroDiaDoMes);
  const [dataFim, setDataFim] = useState(hoje);
  const [carregando, setCarregando] = useState(false);
  const [totais, setTotais] = useState({
    spend: 0, impressions: 0, reach: 0, clicks: 0,
    engajamento: 0, video_views: 0, conversas: 0
  });
  const [campanhaSelecionada, setCampanhaSelecionada] = useState("todas");
  const [iaOpen, setIaOpen] = useState(true);
const [iaLoading, setIaLoading] = useState(false);
const [iaError, setIaError] = useState("");
const [iaResult, setIaResult] = useState(null);
const [iaMeta, setIaMeta] = useState({ cached: false, generated_at: "", scope: null, warning: "" });
const [followersDiario, setFollowersDiario] = useState([]);


const CARD_COLOR = {
  "Resumo (linguagem simples)": "blue",
  "Resumo (para gestor de tráfego)": "purple",
  "Tradução para o negócio": "green",
  "Checagem de desperdício": "orange",
  "Geografia": "teal",
  "O que funcionou": "green",
  "O que prejudicou": "red",
  "Orçamento: como alocar": "blue",
  "Criativo e copy": "purple",
  "Funil e rastreamento": "teal",
  "Hoje (30 min)": "green",
  "Próximas 48 horas": "blue",
  "Próximas 2 semanas": "purple",
  "Regras de escala": "green",
  "Regras de corte": "red",
  "Riscos e atenção": "orange",
  "Limitações do relatório": "gray",
};



  // aceita item com campaign_id (número) ou sem id
const pertenceACampanhaSelecionada = item =>
  !item.campaign_id ||
  campanhaSelecionada === "todas" ||
  String(item.campaign_id) === campanhaSelecionada ||
  item.campaign_id === Number(campanhaSelecionada);

const isCampanhaSelecionada = campanha_id =>
  campanhaSelecionada === "todas" ||
  String(campanha_id) === campanhaSelecionada ||
  campanha_id === Number(campanhaSelecionada);


  useEffect(() => {
  async function carregarThumbnails() {
    if (!dados?.meta_ads_ads?.data) return;

    const ads = dados.meta_ads_ads.data
      .filter((ad) => isCampanhaSelecionada(ad.campaign_id))
      .map((anuncio) => {
        const adItem = {
          id: anuncio.ad_id,
          nome: anuncio.ad_name || "Sem Nome",
          alcance: parseInt(anuncio.reach || 0),
          impressoes: parseInt(anuncio.impressions || 0),
          cliques: parseInt(anuncio.clicks || 0),
          valorGasto: parseFloat(anuncio.spend || 0),
          campaign_id: anuncio.campaign_id,
          campaign_name: anuncio.campaign_name,
          adset_id: anuncio.adset_id,
          adset_name: anuncio.adset_name,
          thumbnail: null,
          conversas: 0,
        };

        (anuncio.actions || []).forEach((a) => {
          if (a.action_type === "onsite_conversion.messaging_conversation_started_7d") {
            adItem.conversas = parseInt(a.value || 0);
          }
        });

        return adItem;
      });

    const adsComThumbs = await Promise.all(
      ads.map(async (ad) => {
        try {
          const resp = await fetch(
            `https://welaunchyou.com.br/crm-wly/api/integracoes/meta_thumbnail_ad.php?ad_id=${ad.id}`
          );
          const thumbData = await resp.json();
          if (thumbData.success && thumbData.thumbnail_url) {
            ad.thumbnail = thumbData.thumbnail_url;
          }
        } catch (e) {
          console.error(`Erro ao carregar thumbnail do anúncio ${ad.id}`, e);
        }
        return ad;
      })
    );

    setAnuncios(adsComThumbs.sort((a, b) => b.conversas - a.conversas));
  }

  carregarThumbnails();
}, [dados, campanhaSelecionada]);


  useEffect(() => {
    async function carregarUsuarios() {
      try {
        const response = await fetch("https://welaunchyou.com.br/crm-wly/api/integracoes/meta_listar_vinculo.php", {
          credentials: "include",
        });
        const data = await response.json();
        if (data.success) {
          setUsuarios(data.data);
        }
      } catch (error) {
        console.error("Erro ao carregar usuários:", error);
      }
    }

    carregarUsuarios();
  }, []);
async function gerarAnaliseIA() {
  try {
    setIaError("");
    setIaLoading(true);

    const selecionado = usuarios.find(u => u.id === Number(usuarioSelecionado));
    if (!selecionado) throw new Error("Nenhum usuário selecionado encontrado!");

    const params = new URLSearchParams({
      data_inicio: dataInicio,
      data_fim: dataFim,
      ad_account_id: selecionado.ad_account_id,
      page_id: selecionado.facebook_page_id,
      ig_user_id: selecionado.instagram_id,
    });

    if (campanhaSelecionada && campanhaSelecionada !== "todas") {
      params.set("campaign_id", campanhaSelecionada);
    }

    const r = await fetch(`/crm-wly/api/integracoes/analisar_meta.php?${params.toString()}`, {
      credentials: "include",
    });

    const j = await r.json().catch(() => null);

    if (r.status === 429) {
      throw new Error("No momento não foi possível gerar uma nova análise. Tente novamente amanhã.");
    }

    if (!r.ok || !j?.success) {
      throw new Error(j?.error || `Erro HTTP ${r.status}`);
    }

    // ✅ Agora guardamos envelope + miolo
    setIaResult(j.analysis || null);
    setIaMeta({
      cached: !!j.cached,
      generated_at: j.generated_at || "",
      scope: j.scope || null,
      warning: j.warning || "",
    });

    setIaOpen(true);
  } catch (e) {
    setIaError(e?.message || "Erro ao gerar análise");
  } finally {
    setIaLoading(false);
  }
}

async function carregarRelatorio(override = {}) {
  if (!usuarioSelecionado) return;

const vinculoId = Number(usuarioSelecionado);
const selecionado = usuarios.find((u) => Number(u.id) === vinculoId);

  if (!selecionado) {
    console.error("Nenhum usuário selecionado encontrado!");
    return;
  }

  // ✅ usa override se vier, senão usa o state atual
  const di = override.data_inicio ?? dataInicio;
  const df = override.data_fim ?? dataFim;

  setCarregando(true);

  try {
    const params = new URLSearchParams({
      data_inicio: di,
      data_fim: df,
      ad_account_id: String(selecionado.ad_account_id || ""),
      page_id: String(selecionado.facebook_page_id || ""),
      ig_user_id: String(selecionado.instagram_id || ""),
    });

    const urlRelatorio = `https://welaunchyou.com.br/crm-wly/api/integracoes/meta_relatorio.php?${params.toString()}`;

const paramsFollowers = new URLSearchParams({
  data_inicio: di,
  data_fim: df,
  ig_user_id: String(selecionado.instagram_id || ""),
  usuario_id: String(selecionado.usuario_id || selecionado.id || ""),
});

const urlFollowers = `https://welaunchyou.com.br/crm-wly/api/integracoes/meta_followers_diario.php?${paramsFollowers.toString()}`;

const [resRelatorio, resFollowers] = await Promise.all([
  fetch(urlRelatorio, { credentials: "include" }),
  fetch(urlFollowers, { credentials: "include" }),
]);

const jsonRelatorio = await resRelatorio.json().catch(() => null);
const jsonFollowers = await resFollowers.json().catch(() => null);

if (!resRelatorio.ok) {
  console.error("Erro HTTP relatório:", resRelatorio.status, jsonRelatorio);
  return;
}

if (!jsonRelatorio?.success) {
  console.error("Erro na resposta do relatório:", jsonRelatorio?.error || "Resposta inválida");
  return;
}

if (!resFollowers.ok) {
  console.error("Erro HTTP followers:", resFollowers.status, jsonFollowers);
  setFollowersDiario([]);
} else if (!jsonFollowers?.success) {
  console.error("Erro na resposta de followers:", jsonFollowers?.error || "Resposta inválida");
  setFollowersDiario([]);
} else {
  setFollowersDiario(jsonFollowers?.data?.series || []);
}

setDados(jsonRelatorio.data);
setCampanhaSelecionada("todas");
  } catch (err) {
    console.error("Erro ao carregar relatório:", err);
  } finally {
    setCarregando(false);
  }
}


  const formatarMoeda = (valor) => Number(valor || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
  const formatarNumero = (valor) => Number(valor || 0).toLocaleString("pt-BR");
  const formatarPorcentagem = (valor) => (Number(valor || 0).toFixed(2) + "%").replace(".", ",");

  const calcularTotais = () => {
    if (!dados?.meta_ads?.data) return {
      spend:0, impressions:0, reach:0, clicks:0,
      engajamento:0, video_views:0, conversas:0
    };

    return dados.meta_ads.data
      .filter((camp) => isCampanhaSelecionada(camp.campaign_id))
      .reduce(
        (tot, camp) => {
          tot.spend += parseFloat(camp.spend || 0);
          tot.impressions += parseInt(camp.impressions || 0);
          tot.reach += parseInt(camp.reach || 0);
          tot.clicks += parseInt(camp.clicks || 0);
          (camp.actions || []).forEach((a) => {
            if (a.action_type === "post_engagement") tot.engajamento += parseInt(a.value || 0);
            if (a.action_type === "video_view") tot.video_views += parseInt(a.value || 0);
            if (a.action_type === "onsite_conversion.messaging_conversation_started_7d") tot.conversas += parseInt(a.value || 0);
          });
          return tot;
        },
        {spend:0, impressions:0, reach:0, clicks:0, engajamento:0, video_views:0, conversas:0}
      );
  };

  useEffect(() => {
    if (!dados) return;
    setTotais(calcularTotais());
  }, [dados, campanhaSelecionada]);

  useEffect(() => {
  setIaResult(null);
  setIaMeta({ cached: false, generated_at: "", scope: null, warning: "" });
  setIaError("");
}, [usuarioSelecionado, dataInicio, dataFim, campanhaSelecionada]);


  const ctrMedia = (totais.clicks / totais.impressions) * 100 || 0;
  const cplMedio = totais.spend / (totais.conversas || 1);
  const frequenciaMedia = totais.reach ? totais.impressions / totais.reach : 0;

const PASTEL_BY_TONE = {
  blue:   "#EAF2FF",
  green:  "#EFFFF4",
  orange: "#FFF4EA",
  purple: "#F6EEFF",
  teal:   "#EAFBF7",
  red:    "#FFEFF3",
  gray:   "#F3F5F7",
};

function resetarRelatorioVisual() {
  setFollowersDiario([]);
  setDados(null);
  setAnuncios([]);
  setCampanhaSelecionada("todas");
  setTotais({
    spend: 0, impressions: 0, reach: 0, clicks: 0,
    engajamento: 0, video_views: 0, conversas: 0
  });
}

function ymdLocal(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}


function renderBullets(title, arr, tone = "gray") {
  if (!Array.isArray(arr) || arr.length === 0) return null;

  const bg = PASTEL_BY_TONE[tone] || PASTEL_BY_TONE.gray;

  return (
    <div className="gads-ai-card" style={{ background: bg }}>
      <div className="gads-ai-card-title">{title}</div>
      <ul className="gads-ai-ul">
        {arr.map((t, idx) => (
          <li key={idx}>{t}</li>
        ))}
      </ul>
    </div>
  );
}





  return (
  <>
  <div className="relatorio-meta-page">
    <h1 className="relatorio-meta-titulo">Relatório de Anúncios Meta</h1>

    <div className="relatorio-meta-scroll">
      <div className="relatorio-meta-wrapper">

            <div className="gads-logo-wrap">
            <img
              className="gads-logo"
              src={`https://welaunchyou.com.br/crm-wly/uploads/logos/meta-logo.png`}
              alt="Google Ads"
            />
          </div>

      {/* 🔵 Filtros */}
      <div className="relatorio-meta-filtro">
        <div className="relatorio-meta-item">
          <label>Selecione o Usuário:</label>
          <select
            value={usuarioSelecionado}
            onChange={(e) => {
              setUsuarioSelecionado(e.target.value);
              setCampanhaSelecionada("todas");
              resetarRelatorioVisual();
            }}
          >
            <option value="">-- Escolha um usuário --</option>
            {usuarios.map((user) => (
              <option key={user.id} value={user.id}>
                {user.facebook_page_name || "Página não informada"}
              </option>
            ))}
          </select>
        </div>

<div className="relatorio-meta-item">
  <DateRangePresets
    label="Período"
    startDate={new Date(`${dataInicio}T12:00:00`)}
    endDate={new Date(`${dataFim}T12:00:00`)}
    onChange={({ start, end }) => {
      setDataInicio(ymdLocal(start));
      setDataFim(ymdLocal(end));
      resetarRelatorioVisual();
    }}
    onApply={({ start, end }) => {
      carregarRelatorio({
        data_inicio: ymdLocal(start),
        data_fim: ymdLocal(end),
      });
    }}
  />
</div>



        <div className="relatorio-meta-item">
          <button onClick={carregarRelatorio}>Gerar Relatório</button>
        </div>
      </div>

      {carregando && (
        <RelatorioSkeleton />
      )}

      {/* Filtro de Campanha */}
        {dados?.meta_ads?.data?.length > 0 && (
          <div className="relatorio-meta-item">
            <label>Campanha:</label>
            <select
              value={campanhaSelecionada}
              onChange={(e) => setCampanhaSelecionada(e.target.value)}
            >
              <option value="todas">Todas as Campanhas</option>
              {dados.meta_ads.data.map((c, i) => (
                <option key={i} value={c.campaign_id}>
                  {c.campaign_name}
                </option>
              ))}
            </select>
          </div>
        )}

      {/* 🔵 Visão Geral */}
{dados && (
  <>
    <h2 className="relatorio-meta-subtitulo" style={{ borderBottom: "none" }}>
      Visão Geral
    </h2>
    <p className="relatorio-meta-explicativo">
      Este painel apresenta as métricas de desempenho de{" "}
      <b>{formatarDataBrasil(dataInicio)}</b> até{" "}
      <b>{formatarDataBrasil(dataFim)}</b>.
    </p>

    <div className="relatorio-meta-cards">
      <div className="relatorio-meta-card">
        <span>Cliques</span>
        <strong>{formatarNumero(totais.clicks)}</strong>
        <p className="relatorio-meta-texto-cards">
          Todos os cliques em seus anúncios
        </p>
      </div>

    <div className="relatorio-meta-card">
      <span>CPL Médio</span>
      <strong>{formatarMoeda(cplMedio)}</strong>
      <p className="relatorio-meta-texto-cards">
        Custo por cada lead/conversa gerada
      </p>
    </div>


      <div className="relatorio-meta-card">
        <span>Alcance</span>
        <strong>{formatarNumero(totais.reach)}</strong>
        <p className="relatorio-meta-texto-cards">
          Pessoas alcançadas no período
        </p>
      </div>

      <div className="relatorio-meta-card">
        <span>Impressões</span>
        <strong>{formatarNumero(totais.impressions)}</strong>
        <p className="relatorio-meta-texto-cards">
          Quantidade de vezes que seus anúncios apareceram
        </p>
      </div>

      <div className="relatorio-meta-card">
        <span>Frequência Média</span>
        <strong>{frequenciaMedia.toFixed(2)}</strong>
        <p className="relatorio-meta-texto-cards">
          Média de vezes que cada pessoa viu seus anúncios
        </p>
      </div>

      <div className="relatorio-meta-card">
        <span>Valor Investido</span>
        <strong>{formatarMoeda(totais.spend)}</strong>
        <p className="relatorio-meta-texto-cards">
          Investimento em tráfego pago total do período
        </p>
      </div>

      <div className="relatorio-meta-card">
        <span>CPM</span>
        <strong>
          {totais.reach > 0
            ? formatarMoeda(totais.spend / (totais.reach / 1000))
            : "-"}
        </strong>
        <p className="relatorio-meta-texto-cards">
          Custo por 1.000 pessoas alcançadas
        </p>
      </div>

      <div className="relatorio-meta-card-conversas">
        <span>Conversas Iniciadas</span>
        <strong>{formatarNumero(totais.conversas)}</strong>
        <p className="relatorio-meta-texto-cards">
          Conversas iniciadas a partir dos seus anúncios
        </p>
      </div>

      <div className="relatorio-meta-card">
        <span>Visualizações de Vídeo</span>
        <strong>{formatarNumero(totais.video_views)}</strong>
        <p className="relatorio-meta-texto-cards">
          Pessoas que assistiram algum dos seus vídeos
        </p>
      </div>
    </div>

    <hr className="linha-pontilhada" />


{/* 🔵 Gráfico 1: Evolução de Alcance, CPL e Investimento por Dia */}
<h2 style={{ borderBottom: "none" }} className="relatorio-meta-subtitulo">
  Evolução de Alcance, CPL e Investimento por Dia
</h2>

<p className="relatorio-meta-explicativo">
  Passe o mouse sobre as linhas para visualizar os números da data.
</p>

<div className="relatorio-meta-grafico">
  <ResponsiveContainer width="100%" height={320}>
 <ComposedChart
  margin={{ top: 10, right: 55, left: 0, bottom: 5 }}
  data={(dados.meta_ads_daily?.data || [])
    .filter(pertenceACampanhaSelecionada)
    .map((item) => ({
      date: item.date_start,
      reach: parseInt(item.reach || 0, 10),
      cpl: parseFloat(item.cpl || 0),
      spend: parseFloat(item.spend || 0),
    }))}
>
  <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e5e7eb" />

  <XAxis
    dataKey="date"
    tick={{ fontSize: 11, fill: "#666" }}
    tickMargin={8}
    tickFormatter={(tick) => {
      const [ano, mes, dia] = String(tick).split("-");
      return `${dia}/${mes}`;
    }}
  />

  <YAxis
    yAxisId="left"
    orientation="left"
    tick={{ fontSize: 11, fill: "#666" }}
    tickMargin={8}
  />

  <YAxis
    yAxisId="cpl"
    orientation="right"
    tick={{ fontSize: 10, fill: "#dc2626" }}
    tickMargin={8}
    tickFormatter={(v) => Math.round(v)}
    domain={[0, "dataMax + 5"]}
    axisLine={false}
    tickLine={false}
    label={{
      value: "CPL (R$)",
      angle: 90,
      position: "insideRight",
      offset: 10,
      style: { fontSize: 11, fill: "#dc2626" },
    }}
  />

  <YAxis
    yAxisId="spend"
    hide={true}
    domain={[0, "auto"]}
  />

  <Tooltip
    contentStyle={{
      borderRadius: "10px",
      border: "1px solid #e5e7eb",
      fontSize: "12px",
    }}
    formatter={(value, name) => {
      if (name === "CPL") return [`R$ ${Number(value).toFixed(2)}`, "CPL"];
      if (name === "Investimento") return [`R$ ${Number(value).toFixed(2)}`, "Investimento"];
      return [Number(value).toLocaleString("pt-BR"), "Alcance"];
    }}
    labelFormatter={(label) => {
      const [ano, mes, dia] = String(label).split("-");
      return `${dia}/${mes}/${ano}`;
    }}
  />

  <Legend wrapperStyle={{ fontSize: 12, paddingTop: 10 }} />

  <Bar
    yAxisId="spend"
    dataKey="spend"
    name="Investimento"
    fill="#10b981"
    fillOpacity={0.25}
    radius={[4, 4, 0, 0]}
  />

  <Line
    yAxisId="left"
    type="monotone"
    dataKey="reach"
    stroke="#007bff"
    name="Alcance"
    strokeWidth={2}
    dot={false}
    activeDot={{ r: 5 }}
  />

  <Line
    yAxisId="cpl"
    type="monotone"
    dataKey="cpl"
    stroke="#e63946"
    name="CPL"
    strokeWidth={2}
    dot={false}
    activeDot={{ r: 5 }}
  />
</ComposedChart>
  </ResponsiveContainer>
</div>

<hr className="linha-pontilhada" />

{followersDiario.length > 0 && (
  <>
    <h2 style={{ borderBottom: "none" }} className="relatorio-meta-subtitulo">
      Seguidores ganhos por dia no Instagram
    </h2>

    <p className="relatorio-meta-explicativo">
      Este gráfico mostra quantos seguidores a conta ganhou em cada dia do período selecionado.
    </p>

    <div className="relatorio-meta-grafico">
      <ResponsiveContainer width="100%" height={340}>
        <ComposedChart
          margin={{ top: 28, right: 55, left: 0, bottom: 5 }}
          data={followersDiario.map((item) => ({
            date: item.date,
            followers_gained: Number(item.followers_gained || 0),
            followers_total: Number(item.followers_total || 0),
          }))}
        >
          <CartesianGrid
            strokeDasharray="3 3"
            vertical={false}
            stroke="#e5e7eb"
          />

          <XAxis
            dataKey="date"
            tick={{ fontSize: 11, fill: "#6b7280" }}
            tickMargin={8}
            axisLine={false}
            tickLine={false}
            tickFormatter={(tick) => {
              const [ano, mes, dia] = String(tick).split("-");
              return `${dia}/${mes}`;
            }}
          />

          <YAxis
            yAxisId="gained"
            orientation="left"
            allowDecimals={false}
            tick={{ fontSize: 11, fill: "#6b7280" }}
            tickMargin={8}
            axisLine={false}
            tickLine={false}
            domain={[0, "dataMax + 3"]}
          />

          <YAxis
            yAxisId="total"
            orientation="right"
            tick={{ fontSize: 10, fill: "#2563eb" }}
            tickMargin={8}
            axisLine={false}
            tickLine={false}
            tickFormatter={(v) => Number(v).toLocaleString("pt-BR")}
            domain={["auto", "auto"]}
            label={{
              value: "Total de seguidores",
              angle: 90,
              position: "insideRight",
              offset: 8,
              style: { fontSize: 11, fill: "#2563eb" },
            }}
          />

          <Tooltip
            contentStyle={{
              borderRadius: "10px",
              border: "1px solid #e5e7eb",
              fontSize: "12px",
            }}
            formatter={(value, name) => {
              if (name === "Seguidores ganhos") {
                return [`+${Number(value).toLocaleString("pt-BR")}`, "Seguidores ganhos"];
              }

              if (name === "Total de seguidores") {
                return [Number(value).toLocaleString("pt-BR"), "Total de seguidores"];
              }

              return [value, name];
            }}
            labelFormatter={(label) => {
              const [ano, mes, dia] = String(label).split("-");
              return `${dia}/${mes}/${ano}`;
            }}
          />

          <Legend wrapperStyle={{ fontSize: 12, paddingTop: 10 }} />

          <Bar
            yAxisId="gained"
            dataKey="followers_gained"
            name="Seguidores ganhos"
            fill="#14b8a6"
            fillOpacity={0.85}
            radius={[6, 6, 0, 0]}
            barSize={44}
          >
            <LabelList
              dataKey="followers_gained"
              position="top"
              formatter={(value) => (Number(value) > 0 ? `+${value}` : "")}
              style={{
                fill: "#0f766e",
                fontSize: 11,
                fontWeight: 600,
              }}
            />
          </Bar>

          <Line
            yAxisId="total"
            type="monotone"
            dataKey="followers_total"
            name="Total de seguidores"
            stroke="#2563eb"
            strokeWidth={2.5}
            dot={{ r: 3, fill: "#2563eb", strokeWidth: 0 }}
            activeDot={{ r: 5 }}
          />
        </ComposedChart>
      </ResponsiveContainer>
    </div>

    <hr className="linha-pontilhada" />
  </>
)}

{/* 🔵 Cidades com mais seguidores (Instagram) */}
{dados?.instagram_cidades?.data?.[0]?.total_value?.breakdowns?.[0]?.results?.length > 0 && (() => {
  const cidadesOrdenadas = [...dados.instagram_cidades.data[0].total_value.breakdowns[0].results]
    .sort((a, b) => b.value - a.value);
  const top5 = cidadesOrdenadas.slice(0, 5);

  const estados = dados?.meta_ads_estado ?? [];

  return (
    <>
      <h2 className="relatorio-meta-subtitulo" style={{ borderBottom: "none" }}>
        Cidades com mais seguidores (Instagram)
      </h2>
      <p className="relatorio-meta-explicativo">
        Abaixo estão as cidades com maior número de seguidores da conta do Instagram no período.
      </p>

      <div style={{ display: "flex", flexWrap: "wrap", gap: "40px", justifyContent: "space-between" }}>
        {/* Tabela de Cidades */}
        <div style={{ flex: "1 1 400px", overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ backgroundColor: "#232335", color: "white" }}>
                <th style={{ padding: "8px", textAlign: "left" }}>Cidade</th>
                <th style={{ padding: "8px", textAlign: "center" }}>Seguidores</th>
              </tr>
            </thead>
            <tbody>
              {cidadesOrdenadas.map((item, index) => (
                <tr
                  key={index}
                  style={{
                    backgroundColor: index % 2 === 0 ? "#f0f8ff" : "#e0f0ff"
                  }}
                >
                  <td style={{ padding: "8px" }}>{item.dimension_values[0]}</td>
                  <td style={{ padding: "8px", textAlign: "center" }}>{item.value}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Tabela de Estados com alcance */}
        <div style={{ flex: "1 1 400px", overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ backgroundColor: "#233527", color: "white" }}>
                <th style={{ padding: "8px", textAlign: "left" }}>Estado</th>
                <th style={{ padding: "8px", textAlign: "center" }}>Alcance</th>
              </tr>
            </thead>
            <tbody>
              {estados.map((estado, index) => (
                <tr
                  key={index}
                  style={{
                    backgroundColor: index % 2 === 0 ? "#e8f8e0" : "#d4f3cc"
                  }}
                >
                  <td style={{ padding: "8px" }}>{estado.estado}</td>
                  <td style={{ padding: "8px", textAlign: "center" }}>{estado.reach}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Gráfico de Pizza */}
      <div style={{ width: "100%", height: 450, marginTop: 50 }}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Tooltip />
            <Pie
              data={top5}
              dataKey="value"
              nameKey="dimension_values[0]"
              cx="50%"
              cy="50%"
              outerRadius={180}
              label={({ name, percent }) => `${name} (${(percent * 100).toFixed(0)}%)`}
            >
              {top5.map((_, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={["#007bff", "#3399ff", "#66b2ff", "#99ccff", "#cce5ff"][index % 5]}
                />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
      </div>

      <hr className="linha-pontilhada" />
    </>
  );
})()}


{/* 🔵 Gráficos: Alcance por Dispositivo e Gênero */}
<h2 style={{ borderBottom: "none" }} className="relatorio-meta-subtitulo">Alcance por Dispositivo e Gênero</h2>
<p className="relatorio-meta-explicativo">
  Número de pessoas alcançadas em cada dispositivo (celular ou computador) e também por gênero (masculino e feminino).
</p>

<div className="relatorio-meta-graficos-duplos">
  {/* Gráfico de Dispositivo */}
  <div className="relatorio-meta-grafico">
    <h3>Dispositivo</h3>
    <p>-</p>
    <ResponsiveContainer width="100%" height={300}>
      <BarChart
        data={Object.values(
          (dados.meta_ads_device?.data || [])
            .filter(pertenceACampanhaSelecionada)
            .reduce((acc, item) => {
              const key = item.device_platform || "Desconhecido";
              acc[key] = acc[key] || { device_platform: key, reach: 0 };
              acc[key].reach += parseInt(item.reach || 0);
              return acc;
            }, {})
        )}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="device_platform" />
        <YAxis />
        <Tooltip />
        <Bar dataKey="reach" fill="#82ca9d" />
      </BarChart>
    </ResponsiveContainer>
  </div>

  {/* 🔵 Tabela: Resultados por Gênero */}
<h2 className="relatorio-meta-subtitulo" style={{ borderBottom: "none" }}>
  Resultados por Gênero
</h2>

<p className="relatorio-meta-explicativo">
  Métricas consolidadas por gênero no período selecionado de{" "}
  <b>{formatarDataBrasil(dataInicio)}</b> até{" "}
  <b>{formatarDataBrasil(dataFim)}</b>.
</p>

<div className="relatorio-meta-tabela-wrapper">
  <table className="relatorio-meta-tabela tabela-genero">
    <thead>
      <tr>
        <th>Gênero</th>
        <th>Mensagens</th>
        <th>Alcance</th>
        <th>Impressões</th>
        <th>Valor Investido</th>
        <th>CPL</th>
        <th>CPM Médio</th>
      </tr>
    </thead>
    <tbody>
      {(() => {
        const agrupado = {};

        (dados.meta_ads_age_gender?.data || [])
          .filter(pertenceACampanhaSelecionada)
          .forEach(item => {
            const genero = item.gender || "unknown";

            if (!agrupado[genero]) {
              agrupado[genero] = {
                gender: genero,
                conversas: 0,
                reach: 0,
                impressions: 0,
                spend: 0
              };
            }

            (item.actions || []).forEach(a => {
              if (a.action_type === "onsite_conversion.messaging_conversation_started_7d") {
                agrupado[genero].conversas += parseInt(a.value || 0);
              }
            });

            agrupado[genero].reach += parseInt(item.reach || 0);
            agrupado[genero].impressions += parseInt(item.impressions || 0);
            agrupado[genero].spend += parseFloat(item.spend || 0);
          });

        return Object.values(agrupado).map((g, idx) => (
          <tr key={idx}>
            <td>
              {g.gender === "male"
                ? "Masculino"
                : g.gender === "female"
                ? "Feminino"
                : "Desconhecido"}
            </td>
            <td>{g.conversas.toLocaleString("pt-BR")}</td>
            <td>{g.reach.toLocaleString("pt-BR")}</td>
            <td>{g.impressions.toLocaleString("pt-BR")}</td>
            <td>{formatarMoeda(g.spend)}</td>
             <td>
              {g.conversas > 0
                ? formatarMoeda(g.spend / g.conversas)
                : "-"}
            </td>
            <td>
              {g.reach > 0
                ? formatarMoeda(g.spend / (g.reach / 1000))
                : "-"}
            </td>
          </tr>
        ));
      })()}
    </tbody>
  </table>
</div>

<hr className="linha-pontilhada" />


  {/* Gráfico de Gênero */}
  <div className="relatorio-meta-grafico">
    <h3>Gênero</h3>
    <p>-</p>
    <ResponsiveContainer width="100%" height={300}>
      <BarChart
        data={Object.values(
          (dados.meta_ads_age_gender?.data || [])
            .filter(pertenceACampanhaSelecionada)
            .reduce((acc, item) => {
              const key = item.gender || "unknown";
              acc[key] = acc[key] || { gender: key, reach: 0 };
              acc[key].reach += parseInt(item.reach || 0);
              return acc;
            }, {})
        )}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          dataKey="gender"
          tickFormatter={(gender) => {
            if (gender === 'male') return 'Masculino';
            if (gender === 'female') return 'Feminino';
            return 'Desconhecido';
          }}
        />
        <YAxis />
        <Tooltip />
        <Bar dataKey="reach">
          {Object.values(
            (dados.meta_ads_age_gender?.data || [])
              .filter(pertenceACampanhaSelecionada)
              .reduce((acc, item) => {
                const key = item.gender || "unknown";
                acc[key] = acc[key] || { gender: key, reach: 0 };
                acc[key].reach += parseInt(item.reach || 0);
                return acc;
              }, {})
          ).map((entry, index) => (
            <Cell
              key={`cell-${index}`}
              fill={
                entry.gender === "male" ? "#80b4ec" :
                entry.gender === "female" ? "#f5acf4" :
                "#cccccc"
              }
            />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  </div>
</div>

<hr className="linha-pontilhada" />

{/* 🔵 Tabela: Resultados por Faixa Etária */}
<h2 className="relatorio-meta-subtitulo" style={{ borderBottom: "none" }}>Resultados por Faixa Etária</h2>
<p className="relatorio-meta-explicativo">
  Métricas alcançadas no período selecionado de <b>{formatarDataBrasil(dataInicio)}</b> até <b>{formatarDataBrasil(dataFim)}</b>.
</p>
<div className="relatorio-meta-tabela-wrapper">
  <table className="relatorio-meta-tabela tabela-faixas">
    <thead>
      <tr>
        <th>Faixa Etária</th>
        <th>Mensagens</th>
        <th>Alcance</th>
        <th>Impressões</th>
        <th>Valor Investido</th>
        <th>CPM Médio</th>
      </tr>
    </thead>
    <tbody>
      {(() => {
        const agrupado = {};
        (dados.meta_ads_age_gender?.data || [])
          .filter(pertenceACampanhaSelecionada)
          .forEach(item => {
            const faixa = item.age;
            if (!agrupado[faixa]) {
                agrupado[faixa] = { age: faixa, conversas: 0, reach: 0, impressions: 0, spend: 0 };
            }
            (item.actions || []).forEach((a) => {
              if (a.action_type === "onsite_conversion.messaging_conversation_started_7d") {
                agrupado[faixa].conversas += parseInt(a.value || 0);
              }
            });

            agrupado[faixa].reach += parseInt(item.reach || 0);
            agrupado[faixa].impressions += parseInt(item.impressions || 0);
            agrupado[faixa].spend += parseFloat(item.spend || 0);
          });

        const faixasOrdenadas = Object.values(agrupado).sort((a, b) => {
          const order = ["18-24", "25-34", "35-44", "45-54", "55-64", "65+"];
          return order.indexOf(a.age) - order.indexOf(b.age);
        });

        return faixasOrdenadas.map((faixa, idx) => (
          <tr key={idx}>
            <td>{faixa.age}</td>
            <td>{faixa.conversas.toLocaleString("pt-BR")}</td>
            <td>{faixa.reach.toLocaleString("pt-BR")}</td>
            <td>{faixa.impressions.toLocaleString("pt-BR")}</td>
            <td>{faixa.spend.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}</td>
            <td>{faixa.reach > 0 ? (faixa.spend / (faixa.reach / 1000)).toLocaleString("pt-BR", { style: "currency", currency: "BRL" }) : "-"}</td>
          </tr>
        ));
      })()}
    </tbody>
  </table>
</div>

<hr className="linha-pontilhada" />
{/* 🔵 Tabela: Principais Anúncios */}
<h2 className="relatorio-meta-subtitulo" style={{ borderBottom: "none" }}>Principais Anúncios</h2>
<p className="relatorio-meta-explicativo">Principais anúncios veiculados, ordenados pela quantidade de conversas iniciadas</p>
<div className="relatorio-meta-tabela-wrapper">
  <table className="relatorio-meta-tabela tabela-anuncios">
    <thead>
      <tr>
        <th>Imagem</th>
        <th>Nome do Anúncio</th>
        <th>Campanha</th>
        <th>Público</th>
        <th>Alcance</th>
        <th>Impressões</th>
        <th>Mensagens</th>
        <th>Valor Investido</th>
      </tr>
    </thead>
    <tbody>
      {anuncios
        .filter(anuncio =>
          isCampanhaSelecionada(anuncio.campaign_id) &&
          anuncio.cliques > 0
        )
          .map((anuncio, idx) => (
          <tr key={idx}>
            <td>
              {anuncio.thumbnail ? (
                <img
                  src={anuncio.thumbnail}
                  alt="Anúncio"
                  width="60"
                  style={{ borderRadius: "8px" }}
                />
              ) : (
                "Sem Imagem"
              )}
            </td>
            <td>{anuncio.nome}</td>
            <td>{anuncio.campaign_name}</td>
            <td>{anuncio.adset_name || "—"}</td>
            <td>{anuncio.alcance.toLocaleString("pt-BR")}</td>
            <td>{anuncio.impressoes.toLocaleString("pt-BR")}</td>
            <td>{anuncio.conversas.toLocaleString("pt-BR")}</td>
            <td>{anuncio.valorGasto.toLocaleString("pt-BR", {
              style: "currency",
              currency: "BRL"
            })}</td>
          </tr>
        ))}
    </tbody>
  </table>
</div>

<hr className="linha-pontilhada" />

{/* 🔵 Tabela: Campanhas */}
<h2 className="relatorio-meta-subtitulo" style={{ borderBottom: "none" }}>Campanhas</h2>
<p className="relatorio-meta-explicativo">
  Campanhas que receberam orçamento no período de <b>{formatarDataBrasil(dataInicio)}</b> até <b>{formatarDataBrasil(dataFim)}</b>.
</p>
<div className="relatorio-meta-tabela-wrapper">
  <table className="relatorio-meta-tabela tabela-campanhas">
    <thead>
      <tr>
        <th>Campanha</th>
        <th>Impressões</th>
        <th>Alcance</th>
        <th>Mensagens</th>
        <th>Investimento</th>
        <th>CTR (%)</th>
        <th>CPC (R$)</th>
      </tr>
    </thead>
    <tbody>
          {(dados.meta_ads.data || [])
            .filter(camp =>
              isCampanhaSelecionada(camp.campaign_id)
            )
            .map((camp, idx) => (
          <tr key={idx}>
            <td>{camp.campaign_name}</td>
            <td>{formatarNumero(camp.impressions)}</td>
            <td>{formatarNumero(camp.reach)}</td>
            <td>
                {formatarNumero(
                  (camp.actions || []).reduce((acc, a) => {
                    if (a.action_type === "onsite_conversion.messaging_conversation_started_7d") {
                      return acc + parseInt(a.value || 0);
                    }
                    return acc;
                  }, 0)
                )}
              </td>

            <td>{formatarMoeda(camp.spend)}</td>
            <td>{formatarPorcentagem(camp.ctr)}</td>
            <td>{formatarMoeda(camp.cpc)}</td>
          </tr>
        ))}
    </tbody>
  </table>
</div>

{/* Sessão Analise IA */}


<section className="gads-ai-wrap">
<div className="gads-ai-head gads-ai-head--stack">
  <div className="gads-ai-title">Análise e recomendações (IA)</div>

  <div className="gads-ai-actions gads-ai-actions--below">
    <button
      type="button"
      className={`gads-ai-btn ${iaLoading ? "is-loading" : ""}`}
      onClick={gerarAnaliseIA}
      disabled={iaLoading}
    >
      {iaLoading ? "Analisando..." : "Receber análise e recomendações"}
    </button>
  </div>
</div>



  {/* mensagem SOMENTE durante o loading */}
  {iaLoading && (
    <div className="gads-ai-hint is-loading">
      Esse processo pode demorar. Levante, estique-se e tome um café!
    </div>
  )}


  {iaError && <div className="gads-ai-error">{iaError}</div>}


{iaResult && !!iaMeta?.generated_at && (
  <div className="gads-ai-subhead">
    <span className="gads-ai-stamp">Atualizada em: {iaMeta.generated_at}</span>
  </div>
)}


  {iaResult && (
  <div className="gads-ai-collapse">
    <button
      type="button"
      className="gads-ai-iconbtn"
      onClick={() => setIaOpen(v => !v)}
      aria-label={iaOpen ? "Ocultar IA" : "Mostrar IA"}
      title={iaOpen ? "Ocultar" : "Mostrar"}
    >
      {iaOpen ? (
        <ArrowUpFromLine size={22} />
      ) : (
        <ArrowDownFromLine size={22} />
      )}
    </button>
  </div>
)}

{/* Corpo da análise — só aparece quando iaOpen = true */}
{iaOpen && iaResult && (
  <div className="gads-ai-body">
    <div className="gads-ai-grid">
      {iaResult?.executive_summary?.plain_language &&
        renderBullets(
          "Resumo (linguagem simples)",
          iaResult.executive_summary.plain_language,
          "blue"
        )}

      {iaResult?.executive_summary?.for_traffic_manager &&
        renderBullets(
          "Resumo (para gestor de tráfego)",
          iaResult.executive_summary.for_traffic_manager,
          "purple"
        )}

        {renderBullets("Tradução para o negócio", iaResult?.scorecard?.business_translation, "green")}
        {renderBullets("Checagem de desperdício", iaResult?.scorecard?.waste_check, "orange")}
        {renderBullets("Geografia", iaResult?.scorecard?.geo, "teal")}

        {renderBullets("O que funcionou", iaResult?.what_worked, "green")}
        {renderBullets("O que prejudicou", iaResult?.what_hurt, "red")}

        {renderBullets("Orçamento: como alocar", iaResult?.budget_allocation, "blue")}
        {renderBullets("Criativo e copy", iaResult?.creative_and_copy, "purple")}
        {renderBullets("Funil e rastreamento", iaResult?.funnel_and_tracking, "teal")}

        {renderBullets("Hoje (30 min)", iaResult?.action_plan?.today_30min, "green")}
        {renderBullets("Próximas 48 horas", iaResult?.action_plan?.next_48h, "blue")}
        {renderBullets("Próximas 2 semanas", iaResult?.action_plan?.next_2weeks, "purple")}

        {renderBullets("Regras de escala", iaResult?.action_plan?.scaling_rules, "green")}
        {renderBullets("Regras de corte", iaResult?.action_plan?.stop_rules, "red")}

        {renderBullets("Riscos e atenção", iaResult?.risks_and_watchouts, "orange")}
        {renderBullets("Limitações do relatório", iaResult?.limitations, "gray")}
      </div>
    </div>
  )}
</section>

</>
)}
</div>
</div>
</div></>
);
}

export default RelatorioMetaCompleto;
